<div class="box-content rd-widget cover-page-widget widget-{{widgetConfig.widgetId}} widgetNoTopBorder" *ngIf="widgetData">
  <div class="fullWidth">
    <div class="table-part">
      <table class="widget-flex" aria-hidden="true">
        <thead>
          <tr class="widget-ruller-flex">
            <th scope="col" class="widget-grid-column" colspan="20">&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="12"><widget-value [align]="'left'" class="title">{{widgetData.street}}, {{widgetData.streetNo}}, {{widgetData.city}} {{widgetData.country}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="12"><widget-value [align]="'left'" class="title">{{widgetData.clientName}}</widget-value></td>
          </tr>
          <tr>
            <td><br /></td>
          </tr>
          <tr>
            <td colspan="12"><widget-value [align]="'left'" class="title-date">{{'coverPage.valuationDate' | rdTranslate}} {{widgetData.valuationDate | rdLocalizedDate}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="12"><widget-value [align]="'left'" class="title-date">{{'coverPage.reportDate' | rdTranslate}} {{widgetData.reportDate | rdLocalizedDate}}</widget-value></td>
          </tr>
          <tr>
            <td colspan="12" *ngIf="widgetData.clientReference !== '' && widgetData.clientReference != null"><widget-value [align]="'left'" class="title-date">{{'coverPage.clientReference' | rdTranslate}} {{widgetData.clientReference}}</widget-value></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
